// Module
var code = "<a ng-click=\"sortByField()\">\n    {{fieldTitle}}\n    <i ng-if=\"displayOptions.sortField === fieldName\" ng-class=\"displayOptions.sortDirection === 'asc' ? 'fa fa-chevron-down' : 'fa fa-chevron-up' \">\n    </i>\n</a>";
// Exports
module.exports = code;